export const SETTINGS = 'settings'
export const COMPACT = 'compact'
